export default __webpack_public_path__ + "static/media/flohmarkt3-3.81c87c7f.jpeg";